import dayjs from 'dayjs';

/**
 * @param num
 */
export const fixedZero = (num: number): string | number => {
  return num < 10 ? `0${num}` : num;
};

/**
 * 将日期格式化为指定的字符串格式
 *
 * @param date - 日期对象，可以是任意格式的日期输入，包括字符串、日期对象等
 * @param fmt - 指定的日期格式字符串，默认值为'YYYY-MM-DD hh:mm'，用于指定日期的格式
 * @returns 返回格式化后的日期字符串
 *
 * 此函数使用dayjs库来处理日期格式化，提供了比原生JavaScript日期对象更简洁易用的接口
 */
export const formattedDate = (
  date: any,
  fmt: string = 'YYYY-MM-DD hh:mm',
): string => {
  return dayjs(date).format(fmt);
};

/**
 * 将给定的日期时间字符串格式化为指定的中文格式
 * @param dateTimeStr 输入的日期时间字符串，格式为"YYYY-MM-DD HH:MM"
 * @returns 返回格式化后的日期时间字符串，格式为"YYYY年MM月DD日 HH:MM"
 */
export const formattedDateTime = (dateTimeStr: string): string => {
  // 解析输入的日期时间字符串
  const parts = dateTimeStr.split(' ');
  const dateParts = parts[0].split('-');
  const timeParts = parts[1].split(':');

  // 提取年、月、日、小时和分钟
  const year = dateParts[0];
  const month = dateParts[1]; // 月份从 0 开始，需要加 1
  const day = dateParts[2];
  const hour = timeParts[0];
  const minute = timeParts[1];

  // 构造新的格式化字符串
  return `${year}年${parseInt(month)}月${day}日 ${hour}:${minute}`;
};

export const formatMonthYear = (dateStr: string): string => {
  // 检查输入是否符合预期的格式
  if (dateStr.length !== 6 || isNaN(parseInt(dateStr))) {
    throw new Error('Invalid input format. Expected a 6-digit string.');
  }

  // 分离年份和月份
  const year = dateStr.substring(0, 4);
  const month = dateStr.substring(4, 6);

  // 格式化输出
  return `${year}年${month}月`;
};

/**
 * 格式化
 */
export const formattedTime = (dateTimeStr: string): string => {
  // 解析输入的日期时间字符串
  const parts = dateTimeStr.split(' ');
  const dateParts = parts[0].split('-');
  const timeParts = parts[1].split(':');

  // 提取年、月、日、小时和分钟
  const year = dateParts[0];
  const month = dateParts[1]; // 月份从 0 开始，需要加 1
  const day = dateParts[2];
  const hour = timeParts[0];
  const minute = timeParts[1];

  // 构造新的格式化字符串
  return `${parseInt(month)}-${day} ${hour}:${minute}`;
};